import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItems } from './menu-items';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/services/auth.service';

@Component({
	selector: 'app-menu',
	templateUrl: './Menu.component.html',
	styleUrls: ['./Menu.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {

	selectedMenu: any = null;
	selectedSubMenu: any = null;
	constructor(public menuItems: MenuItems, private router: Router, private authService: AuthService) {

	}

	ngOnInit() {

	}

	menuClick(value) {
		if (this.selectedMenu === value) {
			this.selectedMenu = null;
		} else {
			this.selectedMenu = value;
		}
	}

	subMenuClick(value) {
		if (this.selectedSubMenu === value) {
			this.selectedSubMenu = null;
		} else {
			this.selectedSubMenu = value;
		}
	}

	get isUserLogged(): boolean {
		return this.authService.isAuthenticated;
	}

	public logOut = async () => {
		await this.authService.logout();
	}
}
